export default {
  title: 'Viikoittainen suorituskyky',
  messages_sent: 'Lähetetyt viestit',
  messages_delivered: 'Toimitetut viestit',
  click_rate: 'Keskimääräinen klikkausprosentti',
  awaiting: 'Odottaa vahvistusta',
  legend: {
    sent: 'Lähetetty',
    clicked: 'Klikattu',
    delivered: 'Toimitettu',
  },
  error_messages: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
